import React, { Fragment, useEffect, useState } from 'react';
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import format from 'date-fns/format';

import { Button, PopoverBody, UncontrolledPopover } from 'reactstrap';
import { UrlEnum } from '../../../../shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faSearchPlus } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { DropdownButton } from '../../../blocks';
import { academicProgramsService } from '../../../../services';
import eventEmitter from "../../../../shared/eventEmitter";

export const ProgramRequestsInstitutionTable = ({ tableData }) => {
    const getWidthStyle = width => ({ width, /*minWidth: width,*/ maxWidth: width });
    const history = useHistory();
    const [data, setData] = useState([]);

    useEffect(() => {
        if (tableData) setData(tableData);
    }, [tableData]);

    const dateFormatter = (cell, row) => {
        const date = new Date(row.lastUpdated);
        return (
            <Fragment>
                {format(date, 'M/d/yyyy')}
                <span className="d-block small">{format(date, 'h:mm aa')}</span>
                {row.status === 'Awaiting Institution' && (
                    <p className="text-italic text-warning nowrap">
                        Sent back to institution
                    </p>
                )}
            </Fragment>
        );
    };
    const programFormatter = (cell, row) => {
        return (
            <Fragment>
                <p className="mb-0">ID: {row.programID}</p>
                <p className="mb-0">{row.programName}</p>
                <p className="text-italic text-muted">{row.degreeLevel}</p>
            </Fragment>
        );
    };
    const cipFormatter = (cell, row) => {
        return (
            <Fragment>
                <p className="mb-0">{row.cipCode}</p>
                <p className="mb-0">{row.cipTitle}</p>
            </Fragment>
        );
    };

    const handleRowCheckboxChange = rowId => {
        setData(prevData =>
            prevData.map(row =>
                row.requestID === rowId ? { ...row, isSelected: !row.isSelected } : row
            )
        );
    };
    const actions = (cell, row) => {
        const idStart = 'PopoverView-' + row.requestID;
        const navState = [{ data: row }];
        return (
            <div className="d-flex">
                <Button
                    className="action-circle"
                    onClick={() => {
                        history.push({
                            pathname: UrlEnum.INSTITUTION_VIEW_ACADEMIC_PROGRAM_REQUESTS,
                            state: navState,
                        });
                    }}
                >
                    <UncontrolledPopover
                        target={idStart + '-view'}
                        trigger="hover"
                        placement="bottom"
                    >
                        <PopoverBody>View</PopoverBody>
                    </UncontrolledPopover>
                    <FontAwesomeIcon id={idStart + '-view'} icon={faSearchPlus} />
                </Button>
            </div>
        );
    };
    const options = {
        showTotal: true,
        firstPageText: 'First',
        prePageText: 'Previous',
        nextPageText: 'Next',
        lastPageText: 'Last',
        sizePerPage: 10,
        hideSizePerPage: true,
        alwaysShowAllBtns: true,
    };
    const columns = [
        {
            dataField: 'lastUpdated',
            text: 'Last Updated',
            sort: true,
            formatter: dateFormatter,
            headerStyle: getWidthStyle(150),
        },
        {
            dataField: 'institutionName',
            text: 'Institution',
            sort: true,
            headerStyle: getWidthStyle(150),
        },
        {
            dataField: 'programName',
            text: 'Program',
            sort: true,
            formatter: programFormatter,
            headerStyle: getWidthStyle(300),
        },
        {
            dataField: 'cipCode',
            text: 'CIP',
            sort: true,
            formatter: cipFormatter,
            headerStyle: getWidthStyle(100),
        },
        {
            dataField: 'description',
            text: 'Description',
            sort: true,
            headerStyle: getWidthStyle(150),
        },
        {
            dataField: 'actions',
            text: '',
            sort: false,
            classes: 'nowrap',
            formatter: actions,

            headerStyle: getWidthStyle(25),
        },
    ];

    const rowClasses = row => {
        return row.status === 'Awaiting Institution' ? 'bg-highlight' : '';
    };

    const getSelectedTableData = () => {
        return data.filter(x => x.isSelected);
    };

    return (
        <div className="card">
            <div
                className="table-responsive hide-scrollbar"
                style={{ overflowX: 'hidden', width: '100%' }}
            >
                <BootstrapTable
                    keyField="requestID"
                    data={data}
                    columns={columns}
                    rowClasses={rowClasses}
                    striped
                    hover
                    pagination={paginationFactory(options)}
                    // defaultSorted={defaultSorted}
                />
            </div>
        </div>
    );
};
